// use only for niche display purposes, such as PropertyInputV2 or PropertyValueDisplay.getDisplayedValue()
export const EMPTY_PROPERTY = {
  calculated: false,
  dataSensitivity: 'none',
  deleted: false,
  description: '',
  displayOrder: 0,
  externalOptions: false,
  fieldType: 'text',
  formField: false,
  groupName: '',
  hasUniqueValue: false,
  hidden: false,
  isCustomizedDefault: false,
  label: '',
  name: '',
  options: [],
  readOnlyDefinition: false,
  mutableDefinitionNotDeletable: false,
  readOnlyValue: false,
  searchableInGlobalSearch: false,
  type: 'string'
};